import { createSlice } from '@reduxjs/toolkit'
import APILoadingStatus from 'types/api-loading-status'
import asyncReducers from '../../../utils/async-reducers'
import { getStatus } from './status.actions'
import { PlatformStatus } from 'services/status'

export type StatusState = {
  loading: APILoadingStatus
  platformStatus: PlatformStatus | null
  reachable: boolean
}

const initialState: StatusState = {
  loading: APILoadingStatus.Idle,
  platformStatus: null,
  reachable: true,
}

const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // getStatus never rejects (the service returns null on failure), so a null
    // payload means unreachable.
    asyncReducers(builder, getStatus, 'loading', (state, action) => {
      state.platformStatus = action.payload
      state.reachable = action.payload !== null
    })
  },
})

export default statusSlice.reducer
export const statusActions = {
  ...statusSlice.actions,
  getStatus,
}
